import { Card, CardBody, Link } from "@heroui/react";

import { Button } from "@heroui/react";

type TutorialFooterProps = {
  title: string;
  description: string;
};

export default function TutorialFooter({
  title,
  description,
}: TutorialFooterProps) {
  return (
    <Card
      className="bg-gradient-to-t from-primary/5 to-transparent border-none"
      radius="lg"
    >
      <CardBody className="p-8 md:p-12">
        <div className="flex flex-col items-center text-center space-y-6">
          <h2 className="text-3xl font-bold tracking-tight">{title}</h2>
          <p className="max-w-2xl text-base opacity-80 leading-relaxed">
            {description}
          </p>
          <div className="flex flex-wrap justify-center gap-4 mt-4">
            <Button as={Link} href="/auth" color="primary">
              Get Started
            </Button>
            <Button as={Link} href="/tutorials" variant="bordered">
              View More Tutorials
            </Button>
          </div>
        </div>
      </CardBody>
    </Card>
  );
}
